import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {SessionActions} from "../../../../shared/actions";
import {ShoppingCart} from "../../../../shared/view-model/store-management/shopping-cart.type";
import {Stock} from "../../../../shared/view-model/stock";
import {AbstractListView} from "../../../../core/visbos-core/ui/components/abstract-list-view";
import {DatatableComponent} from "../../../../core/visbos-core/ui/components/datatable/datatable.component";
import {AbstractControl, FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AbstractVisbosControl} from "../../../../core/visbos-core/ui/forms/abstract-visbos-control";

import * as _ from 'lodash';
import {Packing} from "../../../../shared/view-model/store-management/packing.type";
import {Apollo} from "apollo-angular";
import {getProductPackingsForStockItem} from "../../../services/stock-item-service/stock-item.service";
import {GetProductPackingsForStockItemQuery} from "../../../../shared/graphql/graphql.types";
import {isArray} from "util";

@Component({
  selector: 'vb-add-stocks-to-cart',
  templateUrl: './add-stocks-to-cart.component.html',
  styleUrls: ['./add-stocks-to-cart.component.css']
})
export class AddStocksToCartComponent extends AbstractListView implements OnInit {

  @Input()
  cart: ShoppingCart;

  private _stocks: Stock[] = [];

  get stocks(): Stock[] {
    return this._stocks;
  }

  @Output()
  stocksChange: EventEmitter<Stock[]> = new EventEmitter<Stock[]>();

  @Input()
  set stocks(value: Stock[]) {
    this._stocks = value;
    this.stocksChange.emit(this.stocks);
    this.rows = this.stocks;
  }

  @ViewChild('batchesTmpl')
  batchesTmpl: TemplateRef<any>;

  @ViewChild('orderTmpl')
  orderTmpl: TemplateRef<any>;

  @ViewChild('addStocksTable')
  table: DatatableComponent;

  @Input()
  control: FormGroup;

  packingsForStocks: { [stockCuid: string]: Packing[] } = {};

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private fb: FormBuilder, private apollo: Apollo) {
    super(sessionActions, cd);
  }

  ngOnInit(): void {
    super.ngOnInit();

    if (!this.control) {
      this.control = AddStocksToCartComponent.initAddStockFormGroup(this.fb, this.cart);
    }

    this.columns = [
      {prop: 'label', name: 'Bezeichner', minWidth: 100, flexGrow: 4},
      {name: 'Kritische Chargen', cellTemplate: this.batchesTmpl, minWidth: 50, flexGrow: 2, sortable: false},
      {name: 'Bestellmenge', cellTemplate: this.orderTmpl, minWidth: 50, flexGrow: 2, sortable: false},
    ];

  }

  public static initAddStockFormGroup(fb: FormBuilder, shoppingCart: ShoppingCart): FormGroup {

    const ctrl = fb.group({
      shopping_cart_cuid: [shoppingCart.cuid, Validators.required],
      shopping_cart_item_input: fb.array([], Validators.required)
    });

    return ctrl;
  }

  public static initCartItemFormGroup(fb: FormBuilder): FormGroup {
    return fb.group({
      stock_ids: fb.array([fb.control(null, Validators.required)]),
      product_packing_id: [null, Validators.required],
      amount: [null, Validators.required]
    });
  }

  public setDefaultValues(group: FormGroup) {

    const val = {
      shopping_cart_cuid: this.cart ? this.cart.cuid : null
    };

    group.patchValue(val);

  }

  getShoppingCartItemInputGroup(stockCuid: string) {
    return AbstractVisbosControl.getFormGroupById(this.control.get('shopping_cart_item_input') as FormArray, stockCuid, 'stock_ids.0');
  }

  getShoppingCartItemInputGroupIndex(stockCuid: string) {
    return AbstractVisbosControl.getFormGroupIndexById(this.control.get('shopping_cart_item_input') as FormArray, stockCuid, 'stock_ids.0');
  }

  addSelectedStock(stockCuid) {
    const stock = this.stocks.find(st => st.cuid === stockCuid);

    if (!this.packingsForStocks[stockCuid]) {
      this.apollo.query<GetProductPackingsForStockItemQuery>({
        query: getProductPackingsForStockItem,
        variables: {
          stockItemCuid: stock.stock_item.cuid
        }
      }).toPromise().then(res => {
        this.packingsForStocks[stockCuid] = res.data.productPackings
      });
    }

    const ctrl = AddStocksToCartComponent.initCartItemFormGroup(this.fb);
    ctrl.get('stock_ids.0').setValue(stockCuid);
    (<FormArray>this.control.get('shopping_cart_item_input')).push(ctrl);
  }

  removeSelectedStock(stockCuid) {
    const index = this.getShoppingCartItemInputGroupIndex(stockCuid);
    if (index > -1) {
      (<FormArray>this.control.get('shopping_cart_item_input')).removeAt(index);
    }
  }

  onSelectedChanged(selectedStocks) {

    const old = this.selectedItems;

    const added = _.difference(selectedStocks, old);
    const removed = _.difference(old, selectedStocks);

    for (let st of added) {
      this.addSelectedStock(st);
    }

    for (let st of removed) {
      this.removeSelectedStock(st);
    }

    this.selectedItems = selectedStocks;
  }

  setValidationClasses(ctrl: AbstractControl | AbstractControl[]) {
    let cssClasses = {};

    // Control not set
    if (!ctrl) {
      return cssClasses;
    }

    // Single control
    if (ctrl instanceof AbstractControl) {
      cssClasses = {
        'has-success': ctrl.touched && ctrl.valid,
        'has-error': ctrl.touched && !ctrl.valid,
        'has-warning': !ctrl.touched && !ctrl.valid,
      };
    }

    // Array of controls
    if (isArray(ctrl)) {

      let valid: boolean = true;
      let touched: boolean = false;

      for (let c of <AbstractControl[]>ctrl) {
        if (c && c.invalid) {
          valid = false;
          break;
        }
      }

      for (let c of <AbstractControl[]>ctrl) {
        if (c && c.touched) {
          touched = true;
          break;
        }
      }

      cssClasses = {
        'has-success': touched && valid,
        'has-error': touched && !valid,
        'has-warning': !touched && !valid,
      };

    }

    return cssClasses;
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/procurement/components/add-stocks-to-cart/add-stocks-to-cart.component.ts